export default "__VITE_PUBLIC_ASSET__769133ef__"